import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import { CustomerService } from '../../Services/customer/customer.service';
import { CustomerActions, GetAllCustomers, AddCustomer, EditCustomer, GetCustomerNum, DeleteCustomer, CustomerContactReview, ImportCustomerExcel } from '../actions/customer.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class CustomerEffects {
    constructor(private actions$: Actions,
        private store: Store<IAppState>,
        private customerService: CustomerService
    ) { }

    getAllCustomers$ =  createEffect(() => this.actions$.pipe(
        ofType<GetAllCustomers>(CustomerActions.GetAllCustomers),
        map(action => action.payload),
        mergeMap((payload: any) => this.customerService.getAllCustomers(payload)
            .pipe(map((result: any) => ({ type: '[customer] Set All Customer Success', payload: result })),
                catchError((err) => of({ type: '[customer] Set All Customer Error', payload: err, from: 'getCustomer' }))
            )
        )

    ));


    getaddCustomer$ = createEffect(() => this.actions$.pipe(
        ofType<AddCustomer>(CustomerActions.AddCustomer),
        map(action => action.payload),
        mergeMap((payload: any) => this.customerService.addCustomers(payload)
            .pipe(map((result: any) => ({ type: '[customer] Get Add Customer Success', payload: result, from: 'addCustomer' })),
                catchError((err) => of({ type: '[customer] Get Add Customer Error', payload: err, from: 'addCustomer' }))
            )
        )

    ));

    importCustomerExcel$ = createEffect(() => this.actions$.pipe(
        ofType<ImportCustomerExcel>(CustomerActions.ImportCustomerExcel),
        map(action => action.payload),
        mergeMap((payload: any) => this.customerService.importCustomerExcel(payload)
            .pipe(map((result: any) => ({ type: '[customer] Import Customer Excel Success', payload: result, from: 'importCustomerExcel' })),
                catchError((err) => of({ type: '[customer] Import Customer Excel Error', payload: err, from: 'importCustomerExcel' }))
            )
        )

    ));

    geteditCustomer$ = createEffect(() => this.actions$.pipe(
        ofType<EditCustomer>(CustomerActions.EditCustomer),
        map(action => action.payload),
        mergeMap((payload: any) => this.customerService.editCustomers(payload)
            .pipe(map((result: any) => ({ type: '[customer] Edit Customer Success', payload: result })),
                catchError((err) => of({ type: '[customer] Edit Customer Error', payload: err }))
            )
        )

    ));

    getCustomerNum$ = createEffect(() => this.actions$.pipe(
        ofType<GetCustomerNum>(CustomerActions.GetCustomerNum),
        map(action => action.payload),
        mergeMap((payload: any) => this.customerService.beforeNewCreation(payload)
            .pipe(map((result: any) => ({ type: '[customer] Get Customer Number success', payload: result })),
                catchError((err) => of({ type: '[customer] Get Customer Number Error', payload: err, from: 'addCustomerNum' }))
            )
        )
    ));

    deleteCustomer$ = createEffect(() => this.actions$.pipe(
        ofType<DeleteCustomer>(CustomerActions.DeleteCustomer),
        map(action => action),
        mergeMap((action) => this.customerService.deleteCustomer(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[Customer] Set Delete Customer Success', payload: result })),
                catchError((err) => of({ type: '[Customer] Set Delete Customer Error', payload: err }))
            )
        )
    ));

    contactReviewCustomer$ = createEffect(() => this.actions$.pipe(
        ofType<CustomerContactReview>(CustomerActions.CustomerContactReview),
        map(action => action),
        mergeMap((action) => this.customerService.contactReviewCustomer(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[Customer] Set ContactReview Customer Success', payload: result })),
                catchError((err) => of({ type: '[Customer] Set ContactReview Customer Error', payload: err }))
            )
        )
    ));

}
